export default __webpack_public_path__ + "images/student/avatars/Oolzoo-ed3bf569cfda1653a46f413dc6147d0b.png";